import selfServiceEvents from 'events/selfService';
import uiEvents from 'events/ui';
import uiEnums from 'enums/ui';

export default function updateSelectedAnswer(answerId, answerName) {
  return async (dispatch, getState, { selfServiceGateway }) => {
    const { orgId, orgDomain } = getState().app;
    const { lng } = getState().configuration.config;

    dispatch(selfServiceEvents.updateSelectedAnswer({ answerId, answerName }));

    const response = await selfServiceGateway.getSelectedAnswer(answerId, orgId, orgDomain, lng);
    if (response.error) {
      // TODO // noop for now. we should handle this but previously someone was just logging it
      console.log(`${response.error.reason}: ${response.error.err}`); // eslint-disable-line no-console
      return;
    }

    const answer = response.data;
    dispatch(selfServiceEvents.updateSelectedAnswerSuccess(answer));
    dispatch(uiEvents.navigateForward(uiEnums.LOCATIONS.ANSWER));
  };
}
